module.exports = __webpack_public_path__ + "static/media/cash-funds-v2.f5677e1f.svg";